module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P21"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('p', {
    staticClass: "C120"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/html/05_Preface#page_ix"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "C122"
  }, [_c('a', {
    attrs: {
      "href": "#/html/06_Acknowledgments#page_xv"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "C117"
  }, [_c('a', {
    attrs: {
      "href": "#/html/07_1__Modernist_Form_and_the_Ethics#page_1"
    }
  }, [_vm._v("1. Modernist Form and the Ethics of Otherness")])]), _vm._v(" "), _c('p', {
    staticClass: "C118"
  }, [_c('em', [_c('a', {
    attrs: {
      "href": "#/html/07_1__Modernist_Form_and_the_Ethics#page_1"
    }
  }, [_vm._v("Dusklands")])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/html/07_1__Modernist_Form_and_the_Ethics#page_1"
    }
  }, [_vm._v("and "), _c('em', [_vm._v("In the Heart of the Country")])])]), _vm._v(" "), _c('p', {
    staticClass: "C117"
  }, [_c('span', {
    attrs: {
      "href": "#/html/08_2__Against_Allegory__Waiting_for#page_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2. Against Allegory")])]), _vm._v(" "), _c('p', {
    staticClass: "C118"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/08_2__Against_Allegory__Waiting_for#page_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Waiting for the Barbarians")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/html/08_2__Against_Allegory__Waiting_for#page_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("and "), _c('em', [_vm._v("Life & Times of Michael K")])])]), _vm._v(" "), _c('p', {
    staticClass: "C117"
  }, [_c('span', {
    attrs: {
      "href": "#/html/09_3__The_Silence_of_the_Canon__Foe#page_65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3. The Silence of the Canon")])]), _vm._v(" "), _c('p', {
    staticClass: "C118"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/09_3__The_Silence_of_the_Canon__Foe#page_65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Foe")])])]), _vm._v(" "), _c('p', {
    staticClass: "C117"
  }, [_c('span', {
    attrs: {
      "href": "#/html/10_4__Trusting_the_Other__Age_of_Ir#page_91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4. Trusting the Other")])]), _vm._v(" "), _c('p', {
    staticClass: "C118"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/10_4__Trusting_the_Other__Age_of_Ir#page_91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Age of Iron")])])]), _vm._v(" "), _c('p', {
    staticClass: "C117"
  }, [_c('span', {
    attrs: {
      "href": "#/html/11_5__Expecting_the_Unexpected__The#page_113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5. Expecting the Unexpected")])]), _vm._v(" "), _c('p', {
    staticClass: "C118"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/11_5__Expecting_the_Unexpected__The#page_113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Master of Petersburg")])])]), _vm._v(" "), _c('p', {
    staticClass: "C117"
  }, [_c('span', {
    attrs: {
      "href": "#/html/12_6__Confessing_in_the_Third_Perso#page_138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6. Confessing in the Third Person")])]), _vm._v(" "), _c('p', {
    staticClass: "C118"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/12_6__Confessing_in_the_Third_Perso#page_138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Boyhood")])]), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/html/12_6__Confessing_in_the_Third_Perso#page_138",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("and "), _c('em', [_vm._v("Youth")])])]), _vm._v(" "), _c('p', {
    staticClass: "C117"
  }, [_c('span', {
    attrs: {
      "href": "#/html/13_7__Age_of_Bronze__State_of_Grace#page_162",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7. Age of Bronze, State of Grace")])]), _vm._v(" "), _c('p', {
    staticClass: "C118"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/13_7__Age_of_Bronze__State_of_Grace#page_162",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Disgrace")])])]), _vm._v(" "), _c('p', {
    staticClass: "C120"
  }, [_c('span', {
    attrs: {
      "href": "#/html/14_Epilogue__A_Writer_s_Life__Eliza#page_192",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue: A Writer’s Life")])]), _vm._v(" "), _c('p', {
    staticClass: "C122"
  }, [_c('em', [_c('span', {
    attrs: {
      "href": "#/html/14_Epilogue__A_Writer_s_Life__Eliza#page_192",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Elizabeth Costello")])])]), _vm._v(" "), _c('p', {
    staticClass: "C118"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_Notes#note",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "C118"
  }, [_c('span', {
    attrs: {
      "href": "#/html/15_Works_Cited#page_207",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Works Cited")])]), _vm._v(" "), _c('p', {
    staticClass: "C118"
  }, [_c('span', {
    attrs: {
      "href": "#/html/16_Index#page_219",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b485968","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/04_CONTENTS.vue
// module id = 66
// module chunks = 0